module.exports = __webpack_public_path__ + "img/curved-rail-vertical-left-bottom-stone-path-remnants.3f44056b.png";